<div class="login">
  <div class="container login-container">
    <div class="container-header no-bottom-border">
      <div class="text">Log In</div>
    </div>
    <div class="container-content">
      <div class="container-row">
        <svg-icon src="assets/svg/envelope-circle.svg"></svg-icon>
        <lhpe-input
          class="input"
          controlName="email"
          placeholder="Email"
          [formGroup]="loginForm"
        >
        </lhpe-input>
      </div>
      <div class="container-row">
        <svg-icon src="assets/svg/lock-circle.svg"></svg-icon>

        <lhpe-input
          class="input"
          controlName="password"
          type="password"
          placeholder="Password"
          [formGroup]="loginForm"
        >
        </lhpe-input>
      </div>

      <div class="container-row submit-row">
        <div class="forgot-password">
          <a routerLink="/auth/forgotPassword">Forgot password</a>
        </div>
        <button
          mat-button
          color="lightGreen"
          [disabled]="loginForm.invalid"
          (click)="login()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
